
import { call, put } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError,
} from '../../common/client/sagas/common';

import { getArticleList } from '../serverApi/portal';

export const GET_ARTICLES_ACTION_TYPE = createActionTypes('articles/GET');

function processArticles(data) {
    // ToDo: mutation
    let articles = data?.data?.articles;
    if (articles) {
        data.data.articles = data.data.articles.map(item => {
            return {
                id: item[0],
                name: item[1],
                title: item[2],
                create_date: item[3],
                abstract: item[4],
                text: item[5]
            };
        });
    }
    return data;
}

export function* workGetArticles(options, actionType, action) {
    try {
        yield call(clearActionType);
        yield put({type: actionType.LOADING});
        const data = yield call(
            getArticleList,
            {
                operation: GET_ARTICLES_ACTION_TYPE.DEFAULT
            }
        );
        yield put({type: actionType.SUCCESS, data: processArticles(data)});
    } catch (error) {
        yield call(setOperationError, error, actionType);
    }
}
